import styled from 'styled-components';

export const SpinnerContainer = styled.div`
	width: 100%;
	margin: auto;
`;
